import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RoutesConfig from './config';
import Loading from '../components/Loading/LoadingComponent';
const NotFoundComponent = React.lazy(
  () => import('../components/NotFound/NotFoundComponent'),
);
// Import your components here
// import Home from './Home';
// import About from './About';
// import Contact from './Contact';

const RouterComponent: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={<Loading />}>
        {/* Define your routes here */}
        <Routes>
          {RoutesConfig.map((route, index) => (
            <Route key={index} path={route.path} Component={route.Component} />
          ))}
          <Route path="*" Component={NotFoundComponent} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RouterComponent;
